import CustomizedSnackbars from '../../Notifications/SnackBar';
import { Controller, useForm } from 'react-hook-form';
import {
  Button,
  FormControl,
  Grid,
  Typography,
  FormControlLabel,
  Link,
  Checkbox,
  Dialog,
  DialogContent,
  DialogActions,
  Container,
  Box,
  FormHelperText,
  TextField,
  MenuItem,
} from '@mui/material';
import { Redirect } from 'react-router-dom';
import Turnstile from '../../Common/Turnstile';
import TerminosCondiciones from '../../Screens/TerminosCondiciones';
import Pass from '../../Common/PasswordTextInput';
import EmailTextInput from '../../Common/EmailTextInput';
import CuilTextInput from '../../Common/CuilTextInput';
import NombrePropioTextInput from '../../Common/NombrePropioTextInput';
import DateTextInput from '../../Common/DateTextInput';
import { useParams } from 'react-router-dom';
import ButtonBack from '../../Breadcrumb/ButtonBack';
import {
  validarCrearCuenta,
  verificarIdentidad,
  verificarIdentidadRecuperarPin,
} from '../../../services/Afiliado/Afiliado';
import ConfirmarContactoCrearCuentaView from './ConfirmarContactoCrearCuenta';
import ConfirmarContactoRecuperarPinView from './ConfirmarContactoRecuperarPin';
import ContactoConfirmadoRedirectSignin from './ContactoConfirmadoRedirectSignin';
import CuestionarioValidacionIdentidad from './CuestionarioValidacionIdentidad';
import ContactoConfirmado from '../../Contacto/ContactoConfirmado';
import { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { StepperMobile } from '../../Common/StepperMobile';
import { VideoModalMobile } from '../../Common/VideoModalMobile';

const filledStyle = {
  variant: 'filled',
  // InputProps:{ disableUnderline: true },
  sx: {
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      // borderRadius: '8px',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.08)',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      },
      '&.Mui-focused': {
        backgroundColor: '#ffffff',
      },
    },
  },
};

export const CrearCuentaMobile = (props) => {
  let { validarIdentidad } = useParams();
  const [error, setError] = useState('');
  const [errorAcuerdo, setErrorAcuerdo] = useState(false);
  const [helperAcuerdo, setHelperAcuerdo] = useState('');
  const [errorCorreo, setErrorCorreo] = useState('');
  const [openConfirmarCuenta, setOpenConfirmarCuenta] = useState(false);
  const [errorContrasena, setErrorContrasena] = useState('');
  const [openConfirmarContactoRecuperarPin, setOpenConfirmarContactoRecuperarPin] = useState(false);
  const [datosCuentaReceived, setDatosCuentaReceived] = useState({});
  const [openContactoConfirmado, setOpenContactoConfirmado] = useState(false);
  const [onRedirectPerfil, setRedirectPerfil] = useState(false);

  const {
    register,
    reset,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      sexo: '',
    },
  });

  const [aceptaCondiciones, setAceptaCondiciones] = useState(false);
  const [onCancelar, setOnCancelar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openTerminosCondiciones, setOpenTerminosCondiciones] = useState(false);
  const [response, setResponse] = useState('');
  const [turnstileValidado, setTurnstileValidado] = useState(false);
  const [redirectSignin, setRedirectSignin] = useState(false);
  const [cuil, setCuil] = useState(null);

  const [stepPreguntasNext, setStepPreguntasNext] = useState(false);
  const [respuestas, setRespuestas] = useState(null);
  const [enableSiguiente, setEnableSiguiente] = useState(false);
  const [resetCuestionario, setResetCuestionario] = useState(false);

  const [recuperarPin, setRecuperarPin] = useState(props?.recuperarPin || false);

  useEffect(() => {
    setRecuperarPin(props?.recuperarPin);
    //setLoading(props?.loading === 'show' ? true : false)
  }, [props]);

  const onTurnstileValidado = (validado) => {
    setLoading(false);
    setTurnstileValidado(validado);
  };
  const onTurnstileChange = () => {
    setLoading(true);
  };
  const onTurnstileError = (e) => {
    setLoading(false);
    setError(e);
  };
  const cancelarHandler = () => {
    setOnCancelar(true);
  };

  const handlerCambiarCuenta = async (data, e) => {
    e.preventDefault();
    setErrorCorreo('');
    setErrorContrasena('');
    if (activeStep !== steps.length - 1) {
      if (activeStep === steps.length - 3) {
        handleNextStep(); //si no hay error y si no es el ultimo paso, salto...
        return;
      } else {
        handleNextStep(); //si no es el ultimo paso, salto...
        return;
      }
    }

    let validate = true;
    if (!validarIdentidad) {
      if (data.correo !== data.confirmarCorreo) {
        setErrorCorreo('Los correos no coinciden');
        validate = false;
        setLoading(false);
      }
      if (data.nuevopin !== data.confirmarnuevopin) {
        setErrorContrasena('Las contraseñas no coinciden');
        validate = false;
        setLoading(false);
      }
      if (!aceptaCondiciones) {
        setErrorAcuerdo(true);
        setHelperAcuerdo('Debe aceptar términos y condiciones');
        return;
      }

      if (validate) {
        const cuenta = {
          cuil: data.cuil,
          nombres: data.nombres.trim(),
          apellido: data.apellido.trim(),
          fechaNacimiento: data.fechaNacimiento.trim(),
          sexo: data.sexo,
          correo: data.correo.trim(),
          confirmarCorreo: data.confirmarCorreo.trim(),
          contrasena: data.nuevopin,
          confirmarContrasena: data.confirmarnuevopin,
          aceptaCondiciones: aceptaCondiciones,
          preguntas: respuestas,
        };
        setLoading(true);
        setResponse('');
        setError('');
        try {
          //llamar al endpoint
          const respuesta = recuperarPin
            ? await verificarIdentidadRecuperarPin(cuenta)
            : await validarCrearCuenta(cuenta);

          if (respuesta === 'CORREO_ENVIADO') {
            //abrir vsita confirmar correo
            if (recuperarPin) {
              setOpenConfirmarContactoRecuperarPin(true);
            } else {
              setOpenConfirmarCuenta(true);
            }
            setDatosCuentaReceived(cuenta);
          }
          // setResponse("Correo enviado...");
          //   reset();
          setLoading(false);
        } catch (e) {
          setActiveStep(0);
          setResetCuestionario(true);
          setLoading(false);
        }
      }
    } else {
      if (!aceptaCondiciones) {
        setErrorAcuerdo(true);
        setHelperAcuerdo('Debe aceptar términos y condiciones');
        return;
      }
      const cuenta = {
        cuil: data.cuil,
        nombres: data.nombres,
        apellido: data.apellido,
        fechaNacimiento: data.fechaNacimiento,
        sexo: data.sexo,
        aceptaCondiciones: aceptaCondiciones,
        respuestas: respuestas,
      };
      setLoading(true);
      setResponse('');
      setError('');
      //setError("FALTA llamar a endpoint validarIdentidad para enviar los siguientes datos: "+ JSON.stringify(cuenta))

      let verificar = verificarIdentidad(cuenta);
      verificar
        .then((res) => {
          setLoading(false);
          setRedirectPerfil(true);
          setResponse('Su identidad fue verificada con éxito');
        })
        .catch((e) => {
          setLoading(false);
          setActiveStep(0);
          setResetCuestionario(true);
        });
    }
  };
  const handleClickOpenTerminosCondiciones = () => {
    setOpenTerminosCondiciones(true);
  };
  const handleCloseTerminosCondiciones = () => {
    setOpenTerminosCondiciones(false);
  };

  const handleCloseContactoConfirmado = () => {
    setOpenContactoConfirmado(false);
    setRedirectSignin(true);
  };

  useEffect(() => { }, []);

  const steps = ['Datos Personales', 'Cuestionario', 'Cuenta y Seguridad'];

  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNextStep = () => {
    if (!_canSkip()) {
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  function _canSkip() {
    if (
      errors['cuil'] ||
      errors['nombres'] ||
      errors['apellido'] ||
      errors['fechaNacimiento'] ||
      errors['sexo']
    ) {
      return true;
    } else {
      return false;
    }
  }

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // Probablemente quieras protegerte contra algo como esto,
      // nunca debería ocurrir a menos que alguien esté tratando activamente de romper algo.
      throw new Error('No puedes omitir un paso que no es opcional.');
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handlerTextoBotonSubmit = () => {
    let label = 'Crear';
    if (validarIdentidad) {
      label = 'Validar';
    } else if (recuperarPin) {
      label = 'Recuperar'; //recuperar pin
    }

    return label;
  };

  const handleReset = () => {
    setActiveStep(0);
    reset();
    setResetCuestionario(true);
  };

  const handleSiguiente = (event) => {
    // step del cuestionario
    if (activeStep === 1) {
      setStepPreguntasNext(true);
    }
  };

  const handleRespuestasCuestionario = (value) => {
    setResetCuestionario(false);
    setRespuestas(value);
    setStepPreguntasNext(false);
  };

  const handleBorrarMensaje = () => {
    setError('');
    setResponse('');
  };

  function _renderStepContent(step) {
    switch (step) {
      case 0:
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <FormControl fullWidth={true} error={!!errors.cuil} variant='standard'>
              <CuilTextInput
                register={register}
                errors={setError}
                required={true}
                change={(value) => {
                  setCuil(value);
                }}
                label='CUIL'
                fieldName='cuil'
                error={!!errors.cuil}
                helperText={errors.cuil ? errors.cuil.message : ''}
                {...filledStyle}
              />

              <Link
                target='_blank'
                rel='noopener'
                href='https://www.anses.gob.ar/consulta/constancia-de-cuil'
                underline='hover'
              >
                {'¿Dónde averiguo mi CUIL?'}
              </Link>
            </FormControl>

            <FormControl fullWidth={true} error={!!errors.nombres} variant='standard'>
              <NombrePropioTextInput
                register={register}
                errors={setError}
                required={true}
                label='Nombres'
                fieldName='nombres'
                {...filledStyle}
                error={!!errors.nombres}
                helperText={errors.nombres ? errors.nombres.message : ''}
              />
            </FormControl>

            <FormControl fullWidth={true} error={!!errors.apellido} variant='standard'>
              <NombrePropioTextInput
                register={register}
                errors={setError}
                required={true}
                label='Apellido'
                fieldName='apellido'
                {...filledStyle}
                error={!!errors.apellido}
                helperText={errors.apellido ? errors.apellido.message : ''}
              />
            </FormControl>

            <FormControl fullWidth={true} error={!!errors.fechaNacimiento} variant='standard'>
              <DateTextInput
                register={register}
                errors={setError}
                required={true}
                label='Fecha Nacimiento'
                fieldName='fechaNacimiento'
                {...filledStyle}
                error={!!errors.fechaNacimiento}
                helperText={errors.fechaNacimiento ? errors.fechaNacimiento.message : ''}
              />
            </FormControl>

            <FormControl fullWidth error={!!errors.sexo} variant='standard'>
              <Controller
                name='sexo'
                control={control}
                rules={{ required: 'Debes seleccionar una opción' }}
                render={({ field }) => (
                  <TextField {...field} {...filledStyle} select label='Sexo (según tu documento)'>
                    <MenuItem value='' disabled>
                      Seleccionar...
                    </MenuItem>
                    <MenuItem aria-label='Masculino' value='Masculino'>
                      Masculino
                    </MenuItem>
                    <MenuItem aria-label='Femenino' value='Femenino'>
                      Femenino
                    </MenuItem>
                    <MenuItem aria-label='Otro' value='Otro'>
                      Otro
                    </MenuItem>
                  </TextField>
                )}
              />

              <FormHelperText>{errors.sexo ? errors.sexo.message : ' '}</FormHelperText>
            </FormControl>
          </Box>
        );

      case 1:
        return (
          <>
            <CuestionarioValidacionIdentidad
              cuil={cuil}
              onEnableSiguiente={(value) => {
                setEnableSiguiente(value);
              }}
              onSiguiente={stepPreguntasNext}
              respuestas={respuestas}
              onResultRespuesta={(value) => handleRespuestasCuestionario(value)}
              onResetCuestionario={resetCuestionario}
            />
          </>
        );

      case 2:
        return (
          <>
            {!validarIdentidad && (
              <>
                <FormControl fullWidth={true} error={!!errors.correo} variant='standard'>
                  <EmailTextInput
                    register={register}
                    errors={setError}
                    required={true}
                    label='Correo Electrónico'
                    fieldName='correo'
                    mensajeError='Debe ingresar un correo electrónico'
                    error={!!errors.correo}
                    helperText={errors.correo ? errors.correo.message : ''}
                    {...filledStyle}
                  />
                </FormControl>

                <FormControl fullWidth={true} error={!!errors.confirmarCorreo} variant='standard'>
                  <EmailTextInput
                    register={register}
                    errors={setError}
                    required={true}
                    label='Confirmar Correo Electrónico'
                    fieldName='confirmarCorreo'
                    mensajeError='Debe confirmar un correo electrónico'
                    error={!!errors.confirmarCorreo}
                    helperText={errors.confirmarCorreo ? errors.confirmarCorreo.message : ''}
                    {...filledStyle}
                  />
                </FormControl>

                <FormControl fullWidth={true} error={!!errors.nuevopin} variant='standard'>
                  <Pass
                    register={register}
                    errors={setError}
                    label='Nueva Contraseña'
                    autoComplete='new-password'
                    fieldName='nuevopin'
                    error={!!errors.nuevopin}
                    helperText={errors.nuevopin ? errors.nuevopin.message : ''}
                    {...filledStyle}
                  />
                </FormControl>

                <FormControl fullWidth={true} error={!!errors.confirmarnuevopin} variant='standard'>
                  <Pass
                    register={register}
                    errors={setError}
                    label='Confirmar Nueva Contraseña'
                    autoComplete='new-password'
                    fieldName='confirmarnuevopin'
                    error={!!errors.confirmarnuevopin}
                    helperText={errors.confirmarnuevopin ? errors.confirmarnuevopin.message : ''}
                    {...filledStyle}
                  />
                  <Typography pt={1} variant='body2' color='textSecondary' component='p'>
                    La contraseña debe tener un mínimo de 8 caracteres, 4 letras y 4 números que no
                    deben ser consecutivos o iguales.
                  </Typography>
                </FormControl>
              </>
            )}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 2,
                background: '#fff',
                padding: '24px 24px',
                borderRadius: '8px',
              }}
            >
              <FormControl fullWidth={true} error={errorAcuerdo} variant='standard'>
                <Typography component={'p'}>
                  <b>Es necesario que aceptes los</b>{' '}
                  <Link underline='hover' onClick={handleClickOpenTerminosCondiciones}>
                    {'Términos y Condiciones'}
                  </Link>
                </Typography>
                <FormControlLabel
                  label='Acepto los términos y condiciones'
                  control={
                    <Controller
                      name='aceptaCondiciones'
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={!!field.value}
                          onChange={(e) => {
                            field.onChange(e);
                            setAceptaCondiciones(e.target.checked);
                          }}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      )}
                    />
                  }
                />
                {errorAcuerdo && (
                  <FormHelperText error>{helperAcuerdo}</FormHelperText>
                )}
              </FormControl>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 2,
                background: '#fff',
                padding: '24px 24px',
                borderRadius: '8px',
              }}
            >
              <Turnstile
                sitekey={process.env.REACT_APP_IOSPER_TURNSTILE_SITE_KEY}
                onTurnstileValidado={onTurnstileValidado}
                onChange={onTurnstileChange}
                onError={onTurnstileError}
              />
            </Box>
          </>
        );

      default:
        return <div>Not Found</div>;
    }
  }

  return onRedirectPerfil ? (
    <Redirect
      to={{
        pathname: '/perfil',
        state: { from: '/crearCuenta' },
      }}
    />
  ) : onCancelar || redirectSignin ? (
    <Redirect
      to={{
        pathname: '/',
        state: { from: '/signin' },
      }}
    />
  ) : (
    <Container component='main' maxWidth='sm'>
      <Box
        sx={{
          height: '32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <ButtonBack />
        {!validarIdentidad && !recuperarPin && (
          <VideoModalMobile
            src={'https://www.youtube.com/embed/COb6sCST7To?si=LwgdIbPp4W2qPQli&autoplay=1'}
          />
        )}
      </Box>

      <Typography gutterBottom variant='h5' component='h2'>
        {validarIdentidad && 'Validar Identidad'}
        {!validarIdentidad && !recuperarPin && 'Crear Cuenta '}
      </Typography>

      {recuperarPin && (
        <Typography variant='body1' gutterBottom my={4}>
          Estas intentando cambiar contraseña, por favor valida tu identidad.
        </Typography>
      )}

      <Box sx={{ my: 4 }}>
        <StepperMobile steps={steps} activeStep={activeStep} />
      </Box>

      <form noValidate id='formulario' onSubmit={handleSubmit(handlerCambiarCuenta)}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          {activeStep === steps.length ? (
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reiniciar</Button>
            </Box>
          ) : (
            <>
              {_renderStepContent(activeStep)}

              <FormControl>
                <Button disabled={activeStep === 0} onClick={handleBack}>
                  Anterior
                </Button>
              </FormControl>

              {activeStep === steps.length - 1 ? (
                <FormControl>
                  <LoadingButton
                    variant='contained'
                    color='primary'
                    type='submit'
                    disabled={!turnstileValidado}
                    loading={loading}
                  >
                    {handlerTextoBotonSubmit()}
                  </LoadingButton>
                </FormControl>
              ) : (
                <FormControl>
                  <Button
                    variant='contained'
                    size='medium'
                    type='submit'
                    color='primary'
                    disabled={activeStep === 1 && !enableSiguiente}
                    onClick={(e) => {
                      handleSiguiente(e);
                    }}
                  >
                    Siguiente
                  </Button>
                </FormControl>
              )}
            </>
          )}
        </Box>
      </form>

      <CustomizedSnackbars
        open={response}
        severity='success'
        message={response}
        onDeleteMessage={handleBorrarMensaje}
      />
      <CustomizedSnackbars
        open={error}
        severity='error'
        message={error}
        onDeleteMessage={handleBorrarMensaje}
      />

      <Dialog open={openTerminosCondiciones} onClose={handleCloseTerminosCondiciones}>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item>
              <TerminosCondiciones></TerminosCondiciones>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTerminosCondiciones}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      <ConfirmarContactoCrearCuentaView
        setOpen={setOpenConfirmarCuenta}
        open={openConfirmarCuenta}
        setRedirectSignin={setRedirectSignin}
        datosCuenta={datosCuentaReceived}
        respuestas={respuestas}
      ></ConfirmarContactoCrearCuentaView>

      <ConfirmarContactoRecuperarPinView
        open={openConfirmarContactoRecuperarPin}
        setRedirectSignin={setOpenContactoConfirmado}
        setOpen={setOpenConfirmarContactoRecuperarPin}
        datosCuenta={datosCuentaReceived}
        respuestas={respuestas}
      ></ConfirmarContactoRecuperarPinView>

      <ContactoConfirmadoRedirectSignin
        open={onRedirectPerfil}
        setOpen={setRedirectPerfil}
      ></ContactoConfirmadoRedirectSignin>

      <ContactoConfirmado open={openContactoConfirmado} onClose={handleCloseContactoConfirmado} />
    </Container>
  );
};
